import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {LazyLoadImage} from "react-lazy-load-image-component";
import Logo from "../../images/location_new/singlecase/nj-logo.webp";
import CaseImg from "../../images/location_new/singlecase/nj-web.png";
import {Case_Arrow} from "../../../app-constants";
import {Link} from 'gatsby';

function Singleproject(props) {
    const gradientStyle = {
        background: 'linear-gradient(90deg, #006738 70%, rgb(255, 255, 255) 70%)',
      };
      const ColorStyle = {
        color: '#fff',
      };
      const textAndBackgroundColor = {
        backgroundColor: '',
    
      };
    return (
        <div className="singleproject p-100" style={gradientStyle}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="img_logo">
                            <LazyLoadImage
                                src={Logo}
                                effect="blur" alt="LogoNext" className="img-fluid"
                            />
                        </div>
                        <div className="example" data-text="Feature">
                            <h2 style={ColorStyle}>True Vine Media – A unique networking application</h2>
                        </div>
                        <p style={ColorStyle}>True Vine Media (TVM) is a unique networking application that helps people stay connected with their church and its fellowship.</p>
                        <Link to={`/case-studies/true-vine-media`} className="case_btn"
                              aria-label="TekRevol Contact" style={textAndBackgroundColor}>
                            View Case Study {Case_Arrow}
                        </Link>

                    </Col>
                    <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="technology_list">
                            <div className="tech_name">Web Design</div>
                            <div className="tech_name">UI UX Design</div>
                        </div>
                        <div className="mx-img">
                            <LazyLoadImage
                                src={CaseImg}
                                effect="blur" alt="NXGrad" className="img-fluid"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Singleproject;